/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * TK-31 (v2026_r2) — ĐÈN NEMA phía web: máy chủ có bật NEMA không.
 *
 * Máy chủ cờ `KAPP_NEMA` TẮT thì KHÔNG có route `/api/nema/*` (404). Web hỏi một lần
 * `GET /api/nema/bat` và dựng mọi thứ NEMA theo câu trả lời.
 *
 * 🔴 LUẬT SỐ 0 — BA trạng thái (`nemaThuan.ts`): 'dang-kiem' · 'tat' (đúng 404) · 'bat'.
 * ⛔ Mọi chỗ dựng giao diện NEMA đọc `useNemaBat()` — không chỗ nào tự gọi API thứ hai.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { trangThaiNema, type NemaBat, type TrangThaiNema } from './nemaThuan';

export type { TrangThaiNema, NemaBat } from './nemaThuan';

export const QK_NEMA_BAT = ['nema', 'bat'] as const;

export function useNemaBat(): { trangThai: TrangThaiNema; dev: boolean } {
  const q = useQuery({
    queryKey: QK_NEMA_BAT,
    queryFn: () => api.get<NemaBat>('/api/nema/bat'),
    // Cờ chỉ đổi khi máy chủ khởi động lại — không hỏi lại theo nhịp, không hỏi lại khi quay tab.
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
  return { trangThai: trangThaiNema(q.data, q.error), dev: q.data?.dev ?? false };
}
